import {Component, OnDestroy, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {NgbModal, NgbModalRef, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CALENDAR_LOCALE} from '../../services/constant';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-import-data',
  templateUrl: './import-data.component.html',
  styleUrls: ['./import-data.component.scss']
})
export class ImportDataComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  defaultStartDate: string;
  defaultEndDate: string;
  clickedStartDate: string;
  clickedEndDate: string;
  totalItems = 0;
  currentPage = 1;
  statusData: any;
  selectedStatus: any;
  documentNumber: any;
  calendarLocale = CALENDAR_LOCALE.TH;
  tableCol = [];
  loading = false;
  sortBy: string;
  sortMode: string;
  sentdata = null;
  tableData: any = [];
  modalData: any;
  disable = false;
  modal: NgbModalRef;
  subs: Subscription;
  downloading = false;

  constructor(
    private apiService: ApiService,
    private authService: AuthenticationService,
    private modelService: NgbModule,
    private translate: TranslateService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.loadTexts();
    this.loadData();
  }

  loadTexts() {
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.statusData = [
      {label: this.translate.instant('COMMON.ALL'), value: null},
      {label: this.translate.instant('TEXT.SUCCESS'), value: 'success'},
      {label: this.translate.instant('TEXT.FAILED'), value: 'failed'}
    ];
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      this.tableCol.push(
        {field: 'created_at', header: this.translate.instant('TABLE.IMPORT-DATE')},
        {field: 'invoice_number', header: this.translate.instant('FILTER.INVOICE-NUMBER')},
        {field: 'status', header: this.translate.instant('IMPORT-DATA.STATUS')},
      );
      this.tableCol = _.uniqBy(this.tableCol, 'field');
    });
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.defaultStartDate = moment(this.startDate).format('DD/MM/YYYY');
    this.defaultEndDate = moment(this.endDate).format('DD/MM/YYYY');
  }

  resolveError($event, popup: any, data: any) {
    this.modalData = data;
    this.disable = false;
    this.modal = this.modalService.open(popup, {backdrop: 'static', keyboard: false, centered: true});
  }

  revertBack() {
    this.modal.close();
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  pageChanged() {
    this.sentdata = 1;
    this.loadData(this.currentPage);
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = '';
    } else {
      this.sortMode = '-';
    }
  }

  clearSearch() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.documentNumber = null;
    this.selectedStatus = null;
    this.endDate = new Date();
    this.sortBy = null;
    this.sortMode = null;
    this.totalItems = null;
    this.disable = false;
    this.modal = null;
    this.loadTexts();
    this.loadData();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.loadData();
  }

  loadData(page?) {
    this.clickedStartDate = moment(this.startDate).format('DD/MM/YYYY');
    this.clickedEndDate = moment(this.endDate).format('DD/MM/YYYY');
    this.tableData = [];
    const sniffTargetArr: string[] = [];
    let params = new HttpParams();
    params = params.append('header_issue_date_start', moment(this.startDate).format('YYYY-MM-DD'));
    params = params.append('header_issue_date_end', moment(this.endDate).format('YYYY-MM-DD'));
    if (this.sortBy) {
      params = params.append('ordering', this.sortMode + this.sortBy);
    }
    if (this.sentdata) {
      params = params.append('page', this.currentPage.toString());
      params = params.append('page_size', this.itemsPerPage.toString());
    }
    if (this.selectedStatus) {
      params = params.append('status', this.selectedStatus);
      sniffTargetArr.push('IMPORT-DATA.STATUS-TYPE');
    }

    if (this.defaultStartDate !== this.clickedStartDate || this.defaultEndDate !== this.clickedEndDate) {
      sniffTargetArr.push('TABLE.IMPORT-DATE');
    }

    if (this.documentNumber) {
      params = params.append('invoice_number', this.documentNumber);
      sniffTargetArr.push('FILTER.INVOICE-NUMBER');
    }

    this.loading = true;
    this.apiService.getErrors(params).subscribe(
      (data) => {
        _.forEach(data.results, obj => {
          this.tableData.push({
            'created_at': obj.created_at,
            'status': obj.status,
            'invoice_number': obj.invoice_number,
            'detail': obj.detail.message,
            'row': obj.detail.row ? obj.detail.row : '-'
          });
        });
        if (data) {
          this.totalItems = data.count;
        }
        this.loading = false;
      }
    );

    if (page == null) {
      const sniffTarget = sniffTargetArr.join(', ');
      this.sniff('SEARCH', sniffTarget);
    }
  }

  downloadImportDataReport() {
    let params = new HttpParams();
    params = params.append('header_issue_date_start', moment(this.startDate).format('YYYY-MM-DD'));
    params = params.append('header_issue_date_end', moment(this.endDate).format('YYYY-MM-DD'));
    this.downloading = true;
    this.apiService.downloadImportDataReport(params).subscribe(
      (data) => {
        this.downloading = false;
        const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'import_data_report.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      (err) => {
        this.downloading = false;
        console.log(err.error)
      }
    );

    this.sniff('DOWNLOAD_XLS', 'import_data_report.xlsx');
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'IMPORT_DATA',
      target: target
    };
    this.apiService.sniff(data).subscribe();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data.component.ts